import React, { Component } from 'react';
import Translate from 'react-translate-component';
import translate from 'counterpart';

export default function withTranslatePlaceholder(WrappedComponent) {
    return class TranslatePlaceholder extends Component {
        renderComponent = () => {
            const { placeholder } = this.props;
            const translation = placeholder ? translate(placeholder, { fallback: placeholder }) : '';
            return <WrappedComponent {...this.props} placeholder={translation} />
        }

        render() {
            return <Translate component={this.renderComponent} />;
        }
    };
}
